'use strict';

var ownerDocument = require('./ownerDocument.js');

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

module.exports = ownerWindow;
